import React from 'react'
// import { Link } from "gatsby"

import './title-tab.scss'

export default function TitleTab({ title, className}) {
    return (<div className={className}>
        <h2>{title}</h2>
    </div>)
}